
import { defineComponent } from "vue";
import { ref } from "vue";
import useClipboard from "vue-clipboard3";
import Button from "primevue/button";
import axios from "axios";
import Skeleton from "primevue/skeleton";
import { useRouter, useRoute } from "vue-router";
import store from "../store";

const axioCred = axios.create({
  withCredentials: true,
});

export default defineComponent({
  name: "OrderPrice",
  components: {
    Button,
    Skeleton,
  },
  props: ["order"],
  setup(props) {
    const isLoading = ref(false);
    const error = ref(null);
    const router = useRouter();
    const route = useRoute();
    const calculations = ref(null);
    const getOrderPrice = async () => {
      isLoading.value = true;
      try {
        const json = await axioCred.get(
          `https://www.biletdv.ru/customer/IBEServices/GetOrderPriceInfo?guid=${props.order}`
        );
        let fetchedPass = await json.data;
        calculations.value = fetchedPass;
        console.log(calculations.value);
        
        isLoading.value = false;
      } catch (err) {
        if (err.response.status == 401) {
          store.dispatch("auth/logout");
          router.push("/login");
        }
      }
    };
    return {
      isLoading,
      error,
      calculations,
      getOrderPrice,
    };
  },
  methods: {
    getPaymentType(num: number) {
      switch (num) {
        case 1:
          return "Наличные";
        case 4:
          return "Банковская карта";
        case 9:
          return "Банковская карта";
        case 10:
          return "Банковская карта";
        case 6:
          return "Рапида";
        case 7:
          return "Аванс";
        case 8:
          return "Platron";
        case 11:
          return "КР";
        case 12:
          return "ВТ";
        case 13:
          return "ВЗ";
        case 14:
          return "РТА";
        case 15:
          return "ЮKassa";
        case 16:
          return "ЮKassa (Оплата по частям)";
        default:
          return "Не оплачен";
      }
    },
    getTotalPrice(Passengers: any) {
      let totalPrice = 0;
      for (const elem of Passengers) {
        let items = elem.Items;
        for (const el of items) {
          totalPrice += el.Amount;
        }
      }
      return totalPrice;
    },
    getPriceType(items: any) {
      let newArr: any = [{ Description: "Авиабилет", Amount: 0 }];
      for (const elem of items) {
        if (
          elem.ItemType == 1 ||
          elem.ItemType == 202 ||
          elem.ItemType == 335
        ) {
          newArr[0].Amount += elem.Amount;
        } else {
          newArr.push(elem);
        }
      }
      return newArr;
    },
    saveCheck(check: any) {
      if (new Date(check.Created) < new Date("2021-07-02")) {
        return window.open(`https://check.ofd.ru/rec/2722046551/0001024243050065/9281000100190066/${check.KkmReceiptNumber}/${check.FiscalSign}`, '_blank');
      } else if (new Date(check.Created) < new Date("2021-08-05")) {
        return window.open(`https://check.ofd.ru/rec/2722046551/0002583594045857/9281000100190065/${check.KkmReceiptNumber}/${check.FiscalSign}`, '_blank');
      } else if (new Date(check.Created) < new Date("2024-08-16")) {
        return window.open(`https://check.ofd.ru/rec/2722046551/0002583594045857/9961440300003121/${check.KkmReceiptNumber}/${check.FiscalSign}`, '_blank');
      } else {
        return window.open(`https://check.ofd.ru/rec/2722046551/0002583594045857/7381440800279896/${check.KkmReceiptNumber}/${check.FiscalSign}`, '_blank');
      }
    },
    pushBack() {
      this.$router.back();
    },
  },
  created() {
    this.getOrderPrice();
  },
});
